import React from 'react'
import PropTypes from "prop-types"
import moment from 'moment'
import { keys } from "lodash"
import { Link } from "react-router"
import { connect } from 'react-redux'
import { Panel } from 'react-bootstrap'
import { create as createJsonDiff } from 'jsondiffpatch'

import Button from '../components/Button'
import { getLog } from '../lib/APIClient.js'

import { getText } from "../lib/text"
import { renderSeparator } from './LogTools.jsx'
import LogEntry from './LogEntry.jsx'

const singulars = {
  activities: "activity",
  cities: "city",
  blocks: "block",
  suppliers: "supplier",
  trips: "trip",
  products: "product",
}

/**
 *
 */

class LogViewer extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { log: [] }

    this.jsonDiffInstance = createJsonDiff({
      objectHash: obj => (obj.key || obj._id || obj.id)
    })
  }

  props: {
    // from pappa
    col: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    includeTitle: PropTypes.bool,

    // from connect
    data: PropTypes.object.isRequired,
  }

  defaultProps: {
    includeTitle: true
  }

  componentDidMount() {
    this.updateLog(this.props.col, this.props.id)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.col != nextProps.col || this.props.id != nextProps.id) {
      this.updateLog(nextProps.col, nextProps.id)
    }
  }

  updateLog(col: string, id: string) {
    getLog(col, id).then(log => this.setState({ log }))
  }

  renderEntry(document, entry, entryIdx, log, Activities, Cities, jsonDiffInstance) {
    const isFirstEntry = entryIdx == 0
    const useSeparator = (isFirstEntry || !moment(entry.timestamp).isSame(log[entryIdx - 1].timestamp, 'day'))

    return (
      <React.Fragment>
        { useSeparator && renderSeparator(entry.timestamp) }
        <LogEntry
          entry={entry}
          entryIdx={entryIdx}
          document={document}
          log={log}
          jsonDiffInstance={jsonDiffInstance}
          Activities={Activities}
          Cities={Cities}
        />
      </React.Fragment>
    )
  }

  render() {
    const { id, col, data } = this.props
    const doc = data[col][id]

    if (!doc) return `Doc not found: ${col} - ${id} (in ${keys(data[col]).length})`

    const aok = (
      this.state.log
      && this.state.log.length > 0
      && keys(data[col]).length > 0
      && !!doc
    )

    return (
      <div>
        <h3 style={{ position: "sticky", top: 0 }}>
          {
            this.props.includeTitle && (
              <React.Fragment>
                Log:
                <Link to={`/private/${singulars[col]}/${id}`}>
                  {` ${getText(`logcol_${col}`, "es", true) || col} ${doc.realName || doc.name}`}
                </Link>
              </React.Fragment>
            )
          }
          <Button style={{ marginLeft: 20 }} glyph="refresh" onClick={() => this.updateLog(col, doc._id)}>
            Refresh
          </Button>
        </h3>

        { keys(data[col]).length == 0 && "Loading" }

        {
          (!this.state.log || this.state.log.length == 0) && (
            <Panel bsStyle="warning">
              <Panel.Body>⚠️  Log vacío</Panel.Body>
            </Panel>
          )
        }

        {
          aok && (
            <ol>
              {
                this.state.log.map((entry, i, log) => (
                  this.renderEntry(
                    doc, entry, i, log, this.props.data.activities, this.props.data.cities,
                    this.jsonDiffInstance
                  )
                ))
              }
            </ol>
          )
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  data: {
    trips: state.trips,
    cities: state.cities,
    activities: state.activities,
    routes: state.routes,
    reservations: state.reservations,
    tasks: state.tasks,
    suppliers: state.suppliers,
    products: state.products,
  }
})

export default connect(mapStateToProps)(LogViewer)
